import React from "react";
import { IconName } from "../../../../assets/icons";
import SvgIcon from "../../../SvgIcon/SvgIcon";

interface CategoryButtonSelectableProps {
  id: number;
  name: string;
  isSelected: boolean;
  onClick: (id: number) => void;
  iconName?: IconName;
  disabled?: boolean;
}

/**
 * 🎨 {@code CategoryButtonSelectable}
 * Botón de categoría dentro del modal.
 * Estilo elegante con borde suave, sombra ligera y feedback visual claro.
 */
const CategoryButtonSelectable: React.FC<CategoryButtonSelectableProps> = ({
  id,
  name,
  isSelected,
  onClick,
  iconName = "category",
  disabled = false,
}) => {
  const baseClasses =
    "w-full flex items-center justify-start gap-2 rounded-lg px-5 py-3 text-sm font-medium transition-all duration-200 border shadow-sm";

  const selectedClasses =
    "bg-primary border-primary text-white shadow-md hover:bg-primary/90";

  const defaultClasses =
    "bg-white border-slate-300 text-slate-700 hover:border-primary hover:text-primary hover:bg-primary/5 dark:bg-slate-800 dark:text-slate-200 dark:hover:text-primary";

  const disabledClasses = "cursor-not-allowed opacity-60";

  return (
    <button
      onClick={() => onClick(id)}
      disabled={disabled}
      className={`${baseClasses} ${
        isSelected ? selectedClasses : defaultClasses
      } ${disabled ? disabledClasses : ""}`}
    >
      <SvgIcon name={iconName} width={18} height={18} className="text-inherit" />
      <span className="truncate">{name}</span>
    </button>
  );
};

export default CategoryButtonSelectable;
